
// import {useState, useEffect} from "react";
// import HeroScreen from "./HeroSection";
// import DetailsSection from "./DetailsSection";
// import FeatureIcons from "./FeatureIcons";
// import TestimonialSection from "./TestamonialList";
// import SubscribeSection from "./SubscribeSection";
// import SoulmateCTASection from "./SoulmateCTASection";
// import CongratulationsPopup from "./SubscribePopUp";
import baseURL from "../../authComponents/baseURL/BaseURL";
// import loginToken from "../../authComponents/localStorageItems/LoginTokin";
// import PricingPlans from "./PricingPlans";
// import VideoSection from "./VideoSection";

// const Homepage = () => {
//     const [content, setContent] = useState("");
//     useEffect(() => {
//       const fetchAnnouncement = async () => {
//         try {
//           const response = await baseURL.get("/admin/announcement", {
//             headers: {
//               Authorization: `Bearer ${loginToken}`,
//             },
//           });
//           const data = response.data?.announcement;
//           setContent(data?.content || "");
//         } catch (err) {
//           console.error("Error fetching announcement:", err);
//         }
//       };
  
//       fetchAnnouncement();
//     }, []);
//   return (
//     <>
//       <div className="flex items-center p-3 m-0 bg-black">
//         <div className="w-full md:w-1/12 text-white text-right font-semibold announcement-text-box">
//           Announcement:
//         </div>
//         <div className="flex flex-col items-end w-full md:w-10/12 text-white px-7 announcement-line-container" style={{fontFamily:"serif"}}>
//           <marquee>
//             {content}
//           </marquee>
//         </div>
//       </div>

//       <HeroScreen />
//       <div className="py-6"></div>
//       <CongratulationsPopup />
//       <div className="py-6"></div>
//       <FeatureIcons />
//       <div className="py-6"></div>
//       <VideoSection />
//       <div className="py-6"></div>
//       <DetailsSection />
//       <div className="py-6"></div>
//       {/* <TestimonialSection /> */}
//       {/* <div className="py-6"></div> */}
//       {/* <PricingPlans /> */}
//       <SubscribeSection />
//       <SoulmateCTASection />
//     </>
//   );
// };


// export default Homepage;


import React, { useState } from "react";
import { FaBriefcase, FaChevronRight, FaHeart, FaRegHeart, FaRulerCombined, FaShieldAlt, FaUserPlus, FaUsers, FaUtensils, FaSearch, FaWhatsapp, FaGooglePlay } from "react-icons/fa";
import { HiOutlineShieldCheck } from "react-icons/hi";
import { FaBinoculars } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import loginToken from "../../authComponents/localStorageItems/LoginTokin";
import BrandVideoSection from "./BrandVideoSection";
import VideoSection from "./VideoSection";
import PricingPlans from "./PricingPlans";
import CompatibilitySection from "../../compatibility/CompatibilitySection";
import SEO, { serviceSchema, faqSchema, howToSchema } from "../../../components/seo/SEO";
// Note: organizationSchema & websiteSchema are now in static index.html to be visible without JS
import NotARishtaBureau from "../shared/NotARishtaBureau";
import ProfileVerify from "./ProfileVerify";
import InternationalNewsTicker from "../../reusableComponents/InternationalNewsTicker";
import { IconBadge, PlaneGraphic, MOVING_ABROAD_GRAPHICS } from "../../reusableComponents/MovingAbroadIcons";
import { useFreeOffered } from "../../../utils/freeOffered";
// import RishtaDirectory from "../seo-directory/RishtaDirectory";

export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.selectproposal.app";

// Hero Section Component
const HeroSection = ({ setLoginPopUp }) => {
  const navigate = useNavigate();

  return (
    <header className="relative bg-cover bg-center bg-no-repeat text-white pb-20" style={{
      backgroundImage: `linear-gradient(rgba(59, 0, 0, 0.774), rgba(124, 1, 1, 0.623)), url('/Photos/HeaderBackground.webp')`,
    }}>
      
      <div className="max-w-[1200px] mx-auto px-5 text-center pt-20 pb-16">
        <h1 className="font-playfair text-4xl md:text-5xl lg:text-[3.5rem] font-bold leading-tight mb-5 text-white">
          The Screening Your Family <br />Would Do — Done For You
        </h1>
        <p className="text-lg md:text-xl mb-8 opacity-90 max-w-[760px] mx-auto leading-relaxed">
          Every profile manually verified — ID, education, profession.<br className="hidden md:block" />
          You search, you shortlist, you decide. No middleman, no commission.
        </p>

        {/* Self-service clarifier */}
        <p className="text-base md:text-lg mb-10 font-semibold text-[#e8c87a] max-w-[800px] mx-auto">
          We verify every profile.
        </p>

        {/* View All Profiles CTA */}
        <div className="mb-16">
          <button
            onClick={() => navigate("/all-profiles")}
            className="bg-white text-[#a30000] font-semibold py-4 px-12 rounded-lg hover:bg-gray-100 hover:shadow-lg transition-all duration-300 text-lg"
          >
            Browse Verified Profiles
          </button>
        </div>

        <div className="flex justify-center gap-12 md:gap-16 flex-wrap">
          <div className="text-center">
            <span className="block font-playfair text-3xl md:text-4xl font-bold">
              24/7
            </span>
            <span className="text-xs tracking-wider opacity-80 uppercase">
              Self-Service
            </span>
          </div>
          <div className="text-center">
            <span className="block font-playfair text-3xl md:text-4xl font-bold">
              100%
            </span>
            <span className="text-xs tracking-wider opacity-80 uppercase">
              Manually Screened
            </span>
          </div>
          <div className="text-center">
            <span className="block font-playfair text-3xl md:text-4xl font-bold">
              15+
            </span>
            <span className="text-xs tracking-wider opacity-80 uppercase">
              Countries Served
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

// Features Section Component
const FeaturesSection = () => {
  const features = [
    {
      icon: <FaBriefcase />,
      title: "Detailed Career Profiles",
      description:
        "Filter matches by job title, company, and education level to find financial compatibility.",
      accentColor: "#a30000",
      bgColor: "#fdf2f2",
    },
    {
      icon: <FaUsers />,
      title: "Cultural Preferences",
      description:
        "Search by education, profession, sect and family values to ensure a harmonious union.",
      accentColor: "#7c3aed",
      bgColor: "#f5f3ff",
    },
    {
      icon: <FaUtensils />,
      title: "Lifestyle & Skills",
      description:
        "Share and view details about cooking skills, hobbies, and home management styles.",
      accentColor: "#0891b2",
      bgColor: "#ecfeff",
    },
    {
      icon: <FaRulerCombined />,
      title: "Physical Attributes",
      description:
        "Specific filters for height, age, and other physical preferences important to you.",
      accentColor: "#059669",
      bgColor: "#ecfdf5",
    },
    {
      icon: <FaShieldAlt />,
      title: "Verified Identity",
      description:
        "All profiles are manually screened with phone verification to prevent fake accounts.",
      accentColor: "#d97706",
      bgColor: "#fffbeb",
    },
    {
      icon: <FaHeart />,
      title: "Serious Intentions",
      description:
        "A community strictly for marriage. No casual dating, just serious proposals.",
      accentColor: "#a30000",
      bgColor: "#fdf2f2",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center max-w-[700px] mx-auto mb-16">
          <span className="block text-[#a30000] text-xs font-bold uppercase tracking-wider mb-2.5">
            WHY CHOOSE US
          </span>
          <h2 className="font-playfair text-3xl md:text-[2.5rem] font-bold text-[#222] mb-4">
            Designed for Pakistani Families
          </h2>
          <p className="text-[#555] leading-relaxed">
            We understand that a marriage isn't just between two people, but two
            families. Our detailed filters help you ask the right questions
            before you even meet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-10 rounded-xl shadow-[0_5px_20px_rgba(0,0,0,0.03)] transition-all duration-300 hover:translate-y-[-5px] hover:shadow-lg group cursor-pointer"
              style={{ backgroundColor: feature.bgColor }}
            >
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center text-white text-xl mb-5"
                style={{ backgroundColor: feature.accentColor }}
              >
                {feature.icon}
              </div>
              <h3 className="font-playfair text-xl font-bold text-[#222] mb-2.5">
                {feature.title}
              </h3>
              <p className="text-[#555] text-[0.95rem] leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Process Section Component
const ProcessSection = () => {
  const freeOffered = useFreeOffered();
  const steps = [
    {
      icon: <FaUserPlus className="w-6 h-6" />,
      number: "1",
      title: "Create Your Profile",
      description: (freeOffered ? "Sign up for free. " : "Sign up. ") + "Add your education, profession, family details, and what you're looking for.",
      accent: "#a30000",
    },
    {
      icon: <HiOutlineShieldCheck className="w-6 h-6" />,
      number: "2",
      title: "Get Verified",
      description: "Our team manually reviews every profile to ensure it's genuine before it goes live.",
      accent: "#16803C",
    },
    {
      icon: <FaSearch className="w-6 h-6" />,
      number: "3",
      title: "Browse Matches",
      description: "Search verified profiles with filters — city, education, profession, age, and more.",
      accent: "#a30000",
    },
    {
      icon: <FaBinoculars className="w-6 h-6" />,
      number: "4",
      title: "View Contact Details",
      description: "Upgrade to a plan to unlock daily contact views — phone and WhatsApp details of the people you're interested in.",
      accent: "#7C3AED",
    },
    {
      icon: <FaWhatsapp className="w-6 h-6" />,
      number: "5",
      title: "Connect Directly",
      description: "Reach out via WhatsApp or phone — no middleman. Involve families when ready.",
      accent: "#25D366",
    },
  ];

  return (
    <section className="py-16 pb-24 bg-[#fddbdb] text-center">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center max-w-[700px] mx-auto mb-14">
          <h2 className="font-playfair text-3xl md:text-[2.5rem] font-bold text-[#222] mb-4">
            How Select Proposal Works
          </h2>
          <p className="text-[#555] text-base">
            From signup to Nikkah — a clear, honest process with no hidden steps.
          </p>
        </div>

        {/* Desktop: horizontal timeline */}
        <div className="hidden md:flex items-start justify-center gap-0 relative">
          {steps.map((step, index) => (
            <div key={index} className="flex-1 relative px-3 max-w-[220px]">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="absolute top-[28px] left-[calc(50%+36px)] right-[calc(-50%+36px)] h-[2px] bg-[#d4a0a0] z-0" />
              )}
              {/* Circle */}
              <div
                className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 relative z-10 text-white shadow-lg transition-transform hover:scale-110"
                style={{ backgroundColor: step.accent }}
              >
                {step.icon}
                <div className="absolute -top-1.5 -right-1.5 bg-white text-[#222] w-5 h-5 rounded-full text-[10px] flex items-center justify-center font-bold shadow-sm border border-gray-200">
                  {step.number}
                </div>
              </div>
              <h3 className="font-playfair text-base font-bold text-[#222] mb-1.5 leading-tight">
                {step.title}
              </h3>
              <p className="text-xs text-[#555] leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Mobile: vertical timeline */}
        <div className="md:hidden flex flex-col items-start max-w-[400px] mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="flex gap-4 relative pb-8 last:pb-0">
              {/* Vertical line */}
              {index < steps.length - 1 && (
                <div className="absolute left-[27px] top-[56px] bottom-0 w-[2px] bg-[#d4a0a0]" />
              )}
              {/* Circle */}
              <div className="flex-shrink-0 relative z-10">
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg"
                  style={{ backgroundColor: step.accent }}
                >
                  {step.icon}
                  <div className="absolute -top-1 -right-1 bg-white text-[#222] w-5 h-5 rounded-full text-[10px] flex items-center justify-center font-bold shadow-sm border border-gray-200">
                    {step.number}
                  </div>
                </div>
              </div>
              {/* Text */}
              <div className="text-left pt-1">
                <h3 className="font-playfair text-base font-bold text-[#222] mb-1">{step.title}</h3>
                <p className="text-sm text-[#555] leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 inline-flex items-center gap-2 bg-white/70 backdrop-blur-sm rounded-full px-5 py-2.5 shadow-sm border border-white/50">
          <FaRegHeart className="text-[#a30000] text-sm" />
          <p className="text-xs text-[#555]">
            <span className="font-semibold text-[#222]">{freeOffered ? "Free members" : "Anyone"}</span> can browse every profile{freeOffered ? " and be contacted by paid members" : ""}.{" "}
            <span className="font-semibold text-[#a30000]">Premium plans</span> unlock daily contact views + Compatibility Form access.
          </p>
        </div>
      </div>
    </section>
  );
};

// Stories Section Component
const StoriesSection = () => {
  const stories = [
    {
      image: "/images/stories/couple-1.webp",
      names: "Ahmed & Fatima",
      location: "Lahore → Lahore",
      text: '"As a doctor working 12-hour shifts, I never had time for the traditional rishta process. My mother found Select Proposal and within weeks, we connected with Fatima\'s family. The detailed profiles meant we already knew about each other\'s values and career goals before the first meeting. Alhamdulillah, we\'re now happily married."',
    },
    {
      image: "/images/stories/couple-2.webp",
      names: "Zainab & Ali",
      location: "Karachi → Dubai",
      text: '"My parents were very particular about family background, and I wanted someone who shared my ambition. Select Proposal\'s filters made it easy for my family to find matches that respected our preferences. Ali\'s profile stood out — educated, family-oriented, and now the best husband. Thank you SP!"',
    },
    {
      image: "/images/stories/couple-3.webp",
      names: "Omar & Sana",
      location: "Islamabad → London",
      text: '"Being overseas, finding a genuine rishta back home felt impossible. Every other site was full of fake profiles. Select Proposal\'s manual verification gave us confidence. When I saw Sana\'s verified profile, I knew this was different. Our families spoke, we met, and 4 months later we had our Nikkah."',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="flex justify-between items-end mb-10 flex-wrap gap-4">
          <div>
            <h2 className="font-playfair text-3xl md:text-[2.5rem] font-bold text-[#222]">
              Real People. Real Rishtas.
            </h2>
          </div>
          <Link
            to="/blogs"
            className="text-[#a30000] font-semibold text-sm hover:opacity-80 transition-opacity"
          >
            View all stories →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <div key={index} className="flex flex-col">
              <div className="relative rounded-xl overflow-hidden mb-5 aspect-[4/5] group">
                <img
                  src={story.image}
                  alt={story.names}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5 text-white">
                  <h3 className="font-playfair text-lg font-bold text-white mb-0.5">
                    {story.names}
                  </h3>
                  <span className="text-sm opacity-90">{story.location}</span>
                </div>
              </div>
              <p className="italic text-[#555] text-[0.95rem] leading-relaxed">
                {story.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// CTA Section Component
const CTASection = () => {
  return (
    <section className="bg-[#990000] py-20 text-white overflow-hidden relative" style={{
      backgroundImage: `linear-gradient(135deg, rgba(255,255,255,0.05) 25%, transparent 25%), linear-gradient(225deg, rgba(255,255,255,0.05) 25%, transparent 25%), linear-gradient(45deg, rgba(255,255,255,0.05) 25%, transparent 25%), linear-gradient(315deg, rgba(255,255,255,0.05) 25%, transparent 25%)`,
      backgroundPosition: "10px 0, 10px 0, 0 0, 0 0",
      backgroundSize: "40px 40px",
      backgroundRepeat: "repeat",
    }}>
      <div className="max-w-[1200px] mx-auto px-5 flex flex-col lg:flex-row items-center justify-between">
        <div className="flex-1 lg:pr-12 text-center lg:text-left mb-10 lg:mb-0">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5">
            Ready to find your partner?
          </h2>
          <p className="text-lg mb-8 max-w-[500px] opacity-90 mx-auto lg:mx-0">
            Join Pakistani families who trust Select Proposal to find their
            perfect match. Verified profiles, direct WhatsApp contact, and complete privacy.
          </p>
          <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start">
            <Link
              to="/signup"
              className="inline-block px-8 py-3 bg-white text-[#a30000] rounded-full font-semibold hover:shadow-lg transition-all duration-300"
            >
              Create Account
            </Link>
            <Link
              to="/about"
              className="inline-block px-8 py-3 bg-transparent border-2 border-white/50 text-white rounded-full font-medium hover:border-white transition-all duration-300"
            >
              Learn More
            </Link>
          </div>

          <div className="mt-7 flex justify-center lg:justify-start">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3 bg-black/90 border border-white/30 rounded-xl hover:bg-black transition-colors duration-300"
              aria-label="Download the Select Proposal app on Google Play"
            >
              <FaGooglePlay className="text-2xl" />
              <span className="text-left leading-tight">
                <span className="block text-[10px] uppercase tracking-wider opacity-80">Get it on</span>
                <span className="block text-base font-semibold">Google Play</span>
              </span>
            </a>
          </div>
        </div>

        <div className="flex-shrink-0 flex justify-center">
          <div className="w-[280px] h-[550px] bg-[#111] rounded-[40px] p-3 shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative -rotate-[5deg]">
            <div className="w-full h-full bg-[#333] rounded-[30px] overflow-hidden relative">
              <img
                src="/images/app/app-home.webp"
                alt="Select Proposal Android app home screen"
                loading="lazy"
                width="390"
                height="759"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ─── FAQ Data & Section ──────────────────────────────────────────────── */
const INTL_FAQS = [
  {
    q: "Do you find matches for me?",
    a: "No. Select Proposal is a self-service platform, not a matchmaking or rishta agency. We manually verify every profile; you browse, shortlist and contact families directly. We do not mediate, negotiate or arrange meetings.",
  },
  {
    q: "What is Select Proposal?",
    a: "Select Proposal is Pakistan's most trusted online matrimonial and rishta service. We connect families through verified profiles with advanced filters by education, profession, city, and family values. Registration is completely free."
  },

  {
    q: "How are profiles verified?",
    a: "Every profile is manually screened by our team before approval. We verify identity documents (CNIC/ID card), education or professional details, and personal information. Fake or incomplete profiles are rejected to maintain the highest quality matches for our members."
  },
  {
    q: "Which countries are covered?",
    a: "We serve Pakistanis worldwide — whether you're in Pakistan or anywhere abroad. Our members span across the UK, USA, Canada, UAE, Saudi Arabia, Australia, Europe, and beyond. No matter where you are, Select Proposal helps you find your perfect rishta."
  },
  {
    q: "How do I view someone's contact details?",
    a: null // dynamically built from plans API
  },
  {
    q: "Is my privacy protected?",
    a: "Absolutely. Your contact details are hidden by default and only shown to paid members who spend one of their daily contact views. Select Proposal is a no-photo platform — profiles are matched on education, profession, family and values, never on pictures. We never share your data with third parties."
  },
  {
    q: "How is Select Proposal different from other rishta services?",
    a: "Three things set us apart: (1) Every profile is manually verified by our team — no fakes, no bots. (2) Direct WhatsApp contact — families can connect instantly without waiting for chat requests. (3) Complete privacy control — you choose whether to show or hide your name and photos. No other matrimonial service offers all three."
  }
];

const formatViews = (v, fallback) => {
  const val = v ?? fallback;
  if (val === 'unlimited' || val == null) return 'unlimited views';
  return `${val}/day`;
};

const FREE_CONTACT_FAQ_FALLBACK = "Free accounts can browse every profile, be discovered, and be contacted by paid members — contact views themselves are part of a paid plan. Select Plus allows 5/day, Gold allows 15/day, and Elite allows unlimited views. Contact details include phone number and WhatsApp so families can connect directly and privately.";

const buildContactFaqAnswerIntl = (plans) => {
  const get = (key) => plans.find(p => p.key === key);
  const plus = get('select_plus_male');
  const gold = get('select_gold');
  const elite = get('select_elite');
  return `Free accounts can browse every profile, be discovered, and be contacted by paid members — contact views themselves are part of a paid plan. Select Plus allows ${formatViews(plus && plus.daily_views, 5)}, Gold allows ${formatViews(gold && gold.daily_views, 15)}, and Elite allows ${formatViews(elite && elite.daily_views, 'unlimited')}. Contact details include phone number and WhatsApp so families can connect directly and privately.`;
};

// When the admin has switched Free off for anyone, FAQ copy must not promise
// a free account. Rewrites the few sentences that do.
const stripFreeClaims = (text) =>
  String(text || "")
    .replace(" Registration is completely free.", "")
    .replace("Free accounts can browse every profile, be discovered, and be contacted by paid members — contact views themselves are part of a paid plan.", "Anyone can browse every profile — contact views are part of a paid plan.");

const FAQSection = () => {
  const freeOffered = useFreeOffered();
  const [openIdx, setOpenIdx] = React.useState(null);
  const [faqs, setFaqs] = React.useState(INTL_FAQS);

  React.useEffect(() => {
    baseURL.get('/plans/config').then(res => {
      const plans = res.data?.data?.plans;
      if (plans && plans.length) {
        setFaqs(INTL_FAQS.map(f => f.a === null ? { ...f, a: buildContactFaqAnswerIntl(plans) } : f));
      }
    }).catch(() => {
      setFaqs(INTL_FAQS.map(f => f.a === null ? { ...f, a: FREE_CONTACT_FAQ_FALLBACK } : f));
    });
  }, []);
  return (
    <section className="py-16 px-5" style={{ backgroundColor: '#FDFBF9' }}>
      <div className="max-w-3xl mx-auto">
        <h2 className="font-playfair text-center text-3xl md:text-4xl font-bold mb-3" style={{ color: '#1a1a2e' }}>
          Frequently Asked Questions
        </h2>
        <p className="text-center text-gray-500 mb-10 text-sm">
          Everything you need to know about Select Proposal
        </p>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl overflow-hidden transition-all duration-200"
              style={{
                border: `1px solid ${openIdx === idx ? '#8B1E1E40' : '#e8e0d8'}`,
                backgroundColor: openIdx === idx ? '#fdf8f6' : 'white',
              }}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                <span className="font-semibold text-sm md:text-base pr-4" style={{ color: '#1a1a2e', lineHeight: '1.5' }}>
                  {faq.q}
                </span>
                <span
                  className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold transition-transform duration-200"
                  style={{
                    backgroundColor: openIdx === idx ? '#8B1E1E' : '#f0ebe6',
                    color: openIdx === idx ? 'white' : '#1a1a2e',
                    transform: openIdx === idx ? 'rotate(45deg)' : 'none',
                  }}
                >
                  +
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4 text-sm leading-relaxed" style={{ color: '#555', fontFamily: "'Inter', sans-serif" }}>
                  {freeOffered ? faq.a : stripFreeClaims(faq.a)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Moving Abroad Section
const MovingAbroadSection = () => {
  const navigate = useNavigate();
  const freeOffered = useFreeOffered();
  return (
    <section className="py-16 px-4" style={{ background: 'linear-gradient(135deg, #fef7f7 0%, #f0f4ff 100%)' }}>
      <div className="max-w-5xl mx-auto text-center">
        <IconBadge size={76}>
          <PlaneGraphic size={48} />
        </IconBadge>
        <h2
          className="text-3xl md:text-4xl font-bold mt-4 mb-3"
          style={{ fontFamily: "'Playfair Display', serif", color: '#8B1E1E' }}
        >
          Moving Abroad? Find Your Rishta First
        </h2>
        <p
          className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Moving to another country for studies or work?
          Match with someone heading to the same city — start your new life together.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {[
            { icon: 'graduation', title: 'Students & Professionals', desc: 'Moving abroad for studies or career? Find a partner on the same journey.' },
            { icon: 'destination', title: 'Same City Matching', desc: 'Filter by destination city — connect with someone heading where you are.' },
            { icon: 'rings', title: 'Settle Down Together', desc: 'Start married life in your new country with someone who shares your values.' },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center"
              style={{ border: '1px solid #f0e0e0' }}
            >
              <IconBadge size={64}>
                  {React.createElement(MOVING_ABROAD_GRAPHICS[item.icon], { size: 40 })}
                </IconBadge>
              <h3
                className="text-lg font-semibold mt-3 mb-2"
                style={{ fontFamily: "'Inter', sans-serif", color: '#333' }}
              >
                {item.title}
              </h3>
              <p className="text-gray-500 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <button
            onClick={() => navigate('/signup')}
            className="px-8 py-3 rounded-lg text-white font-semibold text-base hover:opacity-90 transition-opacity"
            style={{ backgroundColor: '#8B1E1E', fontFamily: "'Inter', sans-serif" }}
          >
            {freeOffered ? "Register — It's Free" : "Register Now"}
          </button>
        </div>
      </div>
    </section>
  );
};

// Main HomePage Component
const Homepage = ({ setLoginPopUp }) => {
  return (
    <main>
      <SEO
        title="Select Proposal — Pakistan's Most Trusted Matrimonial & Rishta Service"
        description="Find your perfect rishta on Select Proposal. Pakistan's most trusted matrimonial service with verified profiles, detailed filters by education, profession, city & family values. Register free today."
        path="/"
        jsonLd={[serviceSchema, howToSchema, faqSchema(INTL_FAQS.map(f => ({ question: f.q, answer: f.a })))]}
        hreflangEn="/"
        hreflangUr="/"
        breadcrumbs={[{ name: "Home", path: "/" }]}
      />
      <InternationalNewsTicker />
      <HeroSection setLoginPopUp={setLoginPopUp} />
      <NotARishtaBureau accent="#a30000" />
      <FeaturesSection />
      <CompatibilitySection setLoginPopUp={setLoginPopUp} />
      <ProcessSection />
      <BrandVideoSection />
      <VideoSection />
      <StoriesSection />
      <PricingPlans />
      {/* RishtaDirectory removed from standard homepage */}
      <ProfileVerify />
      <FAQSection />
      <MovingAbroadSection />
      <CTASection />
    </main>
  );
};

export default Homepage;

// Also export individual sections for flexibility
export {
  HeroSection,
  FeaturesSection,
  ProcessSection,
  StoriesSection,
  CTASection,
};
